<template>
    <div class="mainContentAdmin" id="weblogCategories">
      <b-overlay :show="status" no-wrap fixed z-index="9999">
        <template v-slot:overlay>
          <div class="d-flex align-items-center">
            <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
            <b-spinner type="grow" variant="dark" class="mx-1"></b-spinner>
            <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
          </div>
        </template>
      </b-overlay>
      <div id="headersList" style="direction: rtl;">
        <!-- <router-link to="/admin-panel/calibrationLabOrders"> بازگشت </router-link> -->
        <h3>  مشاهده سفارش</h3>
      </div>
      <template>
       <div>
         <StepIndicator   v-if="item.statusId != 7" :steps="steps" :currentStep="currentStep" />
        
      <div class="borderStyle" id="Preinvoice-template">
       <div v-if="item" class="mainTable">
        <div v-if="item" id="customerContent">
        <img :src="item.image" :alt="item.title" />
        <div class="infoGroup">
          <div>
            <p> <span>شماره سفارش :</span>    {{ item.orderNumber }}</p> 
          </div>
          <div>
            <p> <span>نام مشتري :</span>
              {{ item.fullName }}
            </p>
          </div>
        </div>
        <div class="infoGroup">
          <div>
            <p>
            <span>تاريخ ايجاد :</span>
              {{ item.createDate }}
            </p>
          </div>
          <div>
            <p>
            <span>وضعيت سفارش :</span>
              {{ item.statusName }}
            </p>
          </div>
        </div>            
      </div>
       <!-- <table v-if="items.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th>نام کاربری</th>
            <th>فایل ارسالی</th>
            <th>ارسال پیام</th>
          </tr>
          <tr class="trDetail" v-for="item in items" :key="item.id">
            <td>
              {{ item.userName }}
            </td>
            <td>
              <a
                target="_blank"
                :href="`https://test.mmc.ir/${item.documentFile}`"
                >دانلود</a
              >
            </td>
            <td>
              <b-button @click="showSendModal(item.supplierId)" variant="success"
                >ارسال پیام</b-button
              >
            </td>
          </tr>
        </table>
        <b-button
          :class="{ disabled: disable == true }"
          v-if="items.length > 0"
          @click="getReport()"
          variant="primary"
          >گزارش گیری</b-button
        >
        <div class="noItems" v-else>
          <svg
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:osb="http://www.openswatchbook.org/uri/2009/osb"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns:ns1="http://sozi.baierouge.fr"
            id="svg2160"
            sodipodi:docname="OK-2.svg"
            viewBox="0 0 28.912 32.654"
            sodipodi:version="0.32"
            version="1.0"
            inkscape:output_extension="org.inkscape.output.svg.inkscape"
            inkscape:version="0.48.0 r9654"
          >
            <sodipodi:namedview
              id="base"
              fit-margin-left="0"
              inkscape:zoom="11"
              height="64px"
              borderopacity="1.0"
              inkscape:current-layer="layer1"
              inkscape:cx="10.569472"
              inkscape:cy="15.862443"
              fit-margin-right="2.7755576e-017"
              inkscape:grid-bbox="true"
              inkscape:window-maximized="0"
              showgrid="true"
              width="64px"
              inkscape:document-units="px"
              bordercolor="#666666"
              inkscape:window-x="137"
              inkscape:window-y="182"
              fit-margin-bottom="0"
              inkscape:window-width="1330"
              inkscape:pageopacity="0.0"
              inkscape:pageshadow="2"
              pagecolor="#ffffff"
              inkscape:window-height="900"
              fit-margin-top="0"
            />
            <g
              id="layer1"
              inkscape:label="Layer 1"
              inkscape:groupmode="layer"
              transform="translate(-20.653 -15.447)"
            >
              <path
                id="path3207"
                style="fill: #ff0000"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
              <path
                id="path3792"
                style="stroke: #a70000; fill: none"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
            </g>
            <metadata>
              <rdf:RDF>
                <cc:Work>
                  <dc:format>image/svg+xml</dc:format>
                  <dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage"
                  />
                  <cc:license
                    rdf:resource="http://creativecommons.org/licenses/publicdomain/"
                  />
                  <dc:publisher>
                    <cc:Agent rdf:about="http://openclipart.org/">
                      <dc:title>Openclipart</dc:title>
                    </cc:Agent>
                  </dc:publisher>
                  <dc:title>red not OK / failure symbol</dc:title>
                  <dc:date>2011-09-20T10:43:26</dc:date>
                  <dc:description>red not OK / failure symbol</dc:description>
                  <dc:source
                    >https://openclipart.org/detail/161515/red-not-ok--failure-symbol-by-antares42</dc:source
                  >
                  <dc:creator>
                    <cc:Agent>
                      <dc:title>Antares42</dc:title>
                    </cc:Agent>
                  </dc:creator>
                  <dc:subject>
                    <rdf:Bag>
                      <rdf:li>OK</rdf:li>
                      <rdf:li>button</rdf:li>
                      <rdf:li>failure</rdf:li>
                      <rdf:li>green</rdf:li>
                      <rdf:li>icon</rdf:li>
                      <rdf:li>not OK</rdf:li>
                      <rdf:li>red</rdf:li>
                      <rdf:li>success</rdf:li>
                    </rdf:Bag>
                  </dc:subject>
                </cc:Work>
                <cc:License
                  rdf:about="http://creativecommons.org/licenses/publicdomain/"
                >
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Reproduction"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Distribution"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
                  />
                </cc:License>
              </rdf:RDF>
            </metadata>
          </svg>
  
          <p>اطلاعاتی برای نمایش وجود ندارد</p>
        </div>-->
      </div> 
      <div v-if="itemsList" class="mainTable">
        <table v-if="itemsList.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th>  شرح خدمات</th>
            <th>  گستره</th>
            <th>  توضيحات</th>
            <th>  نوع</th>
            <th> قيمت (ريال)</th>
            <th> تعداد</th>
            <th>مبلغ كل (ريال)</th>
          </tr>
          <tr class="trDetail" v-for="itemL in itemsList" :key="item.id" >
            <td>
              {{ itemL.name }}
            </td>
            <td>
              {{ itemL.range }}
            </td>
            <td>
              {{ itemL.description }}
            </td>
            <td>
              {{ itemL.calibrationType }}
            </td>
            <td>
              {{  currencyWithoutRial( itemL.price) }}
            </td>
            <td>
              {{ formatPersianNumber( itemL.number) }}
            </td>
            <td>
              {{ currencyWithoutRial( itemL.priceLine) }}
            </td>          
          </tr>
        </table>
        <table class="table text-right">
          <tr class="trDetail">
            <td colspan="6" style="text-align: right;font-weight: bold;border-left:0px;"> هزينه مازاد: </td>
            <!-- <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td>  -->
            <td  v-if="item.statusId == 5 "  style="text-align: left;font-weight: bold;">
                <!-- {{  additionalCost }}  -->
                <input type="number"  class="text-center"  v-model="totalAdditionalCost"  placeholder="هزينه مازاد را وارد نماييد." />
            </td>
            <td   class="hideBorder" v-else style="text-align: left;font-weight: bold;">
                 {{ currency( item.totalAdditionalCost )}}
            </td>
          </tr>
          <tr class="trDetail">
            <td  colspan="6" style="text-align: right;font-weight: bold;border-left:0px;">  تخفيف: </td>
            <!-- <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder" > </td>
            <td class="hideBorder"></td> -->
            <td v-if="item.statusId == 5 " style="text-align: left;font-weight: bold;">  
              <!-- {{  discount }} -->
              <input type="number"  class="text-center"  v-model="totalDiscount"  placeholder="تخفيف را وارد نماييد." />
             </td>
             <td   class="hideBorder" v-else style="text-align: left;font-weight: bold;">  
                {{ currencyWithoutRial(item.totalDiscount)  }} %
             </td>
          </tr>
          <tr class="trDetail">
            <td colspan="6" style="text-align: right;font-weight: bold;border-left:0px;"> مالیات: </td>
            <!-- <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td> -->
            <td  class="hideBorder" v-if="item.totalTax == 0 || item.statusId == 5"  style="text-align: left;font-weight: bold;">  {{  taxOnCart }} </td>
            <td  class="hideBorder" v-else style="text-align: left;font-weight: bold;">  {{  currency(item.totalTax) }} </td>
          </tr>
          <tr class="trDetail">
            <td  colspan="6" style="text-align: right;font-weight: bold;border-left:0px;"> مبلغ نهايي:</td>
            <!-- <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td>
            <td class="hideBorder"></td> -->
             <td  class="hideBorder" v-if="item.totalPrice  == 0 || item.statusId == 5"  style="text-align: left;font-weight: bold;">  {{ finalAmountWithTax }}</td>
             <td class="hideBorder" v-else style="text-align: left;font-weight: bold;">  {{ currency( item.totalPrice )}}</td>
          </tr>
        </table>
      </div>
      <div  v-if="item.statusId == 5 "  style="text-align: right;font-weight: bold;direction: rtl;">
                <!-- <input type="textarea"  class="text-center width100" v-model="textAdditionalCost"  placeholder="توضيحات  را وارد نماييد." /> -->
                <textarea
              v-model="descriptionOrder"
              placeholder="توضيحات  را وارد نماييد."
              class="textarea"
              id=""
              cols="148"
              rows="5"
            ></textarea>
     </div>
      <div  v-else style="text-align: right;font-weight: bold;direction: rtl;">
         <span> توضيحات : </span>  {{  item.descriptionOrder }}
      </div>  
      </div>

      <div class="borderStyle" id="messageContent">
        <div id="messages">
          <p v-for="(message,index) in messages" :key="index" :class="{'calibrationLabMessage':message.forAdmin==true}">
            {{message.message}}
          </p>
        </div>
        <div id="sendMessageBox">
  
          <b-form-group label="پیام" class="headerStyle">
            <b-form-textarea v-model="message" placeholder="پیام را وارد کنید">
            </b-form-textarea>
          </b-form-group>
           <b-button  variant="primary" @click="sendMessageCustomer(item.id,getRole)"> ارسال پیام </b-button> 
        </div>
      </div>
      <b-button   v-if="item.statusId == 6 || item.statusId == 7" id="preInvoice-print" @click="printInvoice(item.orderNumber)"  variant="warning" >چاپ پيش فاكتور</b-button>
      <!-- <div class="borderStyle" v-if="item.statusId == 5  && getRole !='CalibrationLab' ">
          <b-form-group label="فايل پيش فاكتور" class="headerStyle">
          <b-form-file
              v-if="disabled ? !disabled : true"
              v-model="files"
              placeholder="فاكتور سفارش آپلود شود."
            >
            </b-form-file>
          </b-form-group>
        </div> -->
        <div class="borderStyle" v-if="item.statusId == 6  && getRole =='CalibrationLab' && item.urlFactor == null ">
          <b-form-group label="فايل فيش واريزي" class="headerStyle">
          <b-form-file
              v-if="disabled ? !disabled : true"
              v-model="files"
              placeholder=" فيش واريزي سفارش آپلود شود."
              multiple
            >
            </b-form-file>
          </b-form-group>
          <b-button  
          variant="success" 
          :disabled="!files || files.length === 0"
          @click="sendReceiptDeposit(item)"> ارسال فيش واريزي </b-button> 
        </div>
         <section>
                <!-- <h2>پیش‌نمایش فایل‌ها </h2> -->
             <!-- مقدار baseFolder را به پوشه پایه بدهید -->
            <FilePreviewGrid :baseFolder="item.urlFactor" />
         </section>
        <!-- <a
              class="videoPreviewButton"
              v-if="item.statusId == 6 || item.statusId == 7"
              :href="item.urlFactor"
              target="_blank"
              >دريافت پيش فاكتور
          </a> -->
          <!-- <div v-if="item.statusId == 6 || item.statusId == 7">
                 <InvoiceTemplate :invoice="invoiceData" ref="invoice" />
                 <button @click="downloadPdf">دريافت پيش فاكتور</button>
          </div> -->
      <div class="links">
         <div v-if="item.statusId == 1 && getRole !='CalibrationLab'" >           
              <button v-if="disabled == false" class="btn btn-success" @click="nextStep(item,2)"> تاييد سفارش </button>
              <button v-if="disabled == false" class="btn btn-danger" @click="nextStep(item,3)">رد سفارش </button>
              <b-button v-else class="disableLink" type="button" variant="primary"> در حال ثبت </b-button>
         </div>
         <div v-if="item.statusId == 2 && getRole !='CalibrationLab' " >
              <b-button v-if="disabled == false" class="btn btn-success" @click="nextStep(item,4)">دريافت تجهيزات</b-button>
              <b-button v-else class="disableLink" type="button" variant="primary"> در حال ثبت </b-button>
         </div>
         <div v-if="item.statusId == 4  && getRole !='CalibrationLab' " >
              <b-button v-if="disabled == false" class="btn btn-success" @click="nextStep(item,5)"> شروع کالیبراسیون </b-button>
              <b-button v-else class="disableLink" type="button" variant="primary"> در حال ثبت </b-button>
         </div>
         <div v-if="item.statusId == 5  && getRole !='CalibrationLab' " >
              <b-button v-if="disabled == false" class="btn btn-success" @click="nextStep(item,6)"> در انتظار پرداخت</b-button>
              <!-- <b-button v-if="disabled == false" class="btn btn-warning" @click="uploadFactor(item,6)">آپلود فاكتور</b-button> -->
              <b-button v-else class="disableLink" type="button" variant="primary"> در حال ثبت </b-button>
         </div>
         <div v-if="item.statusId == 6 && getRole !='CalibrationLab' " >
              <b-button v-if="disabled == false" class="btn btn-success" @click="nextStep(item,7)"> اتمام کالیبراسیون</b-button>
              <b-button v-else class="disableLink" type="button" variant="primary"> در حال ثبت </b-button>
         </div>
         <div v-if="item.statusId == 1 && getRole =='CalibrationLab'" >           
              <b-button v-if="disabled == false" class="btn btn-danger" @click="nextStep(item,8)">لغو سفارش </b-button>
              <b-button v-else class="disableLink" type="button" variant="primary"> در حال ثبت </b-button>
         </div>
         <router-link   class="btn btn-info" to="/admin-panel/calibrationLabOrders"> بازگشت </router-link>
      </div>
       </div>
      </template>
      <!-- <b-modal
        id="sendmodal"
        hide-footer
        ref="sendModal"
        no-close-on-backdrop
        v-model="sendModal"
        @close="resetSendModal()"
        title="ارسال پیام"
      >
        <div id="sendMessageContent">
          <label for="">پیام خود را وارد کنید</label>
          <textarea
            style="width: 320px; height: 280px"
            v-model="message"
          ></textarea>
          <input type="submit" value="ارسال" @click="sendMessage()" />
        </div>
      </b-modal> -->
    </div>
  </template>
  <script>
  import FilePreviewGrid from '@/components/admin/shared/filePreviewGrid.vue'
  import StepIndicator from '@/components/admin/shared/StepIndicator.vue';
  import adminMixin from "@/libraries/adminController.js";
  import SInputs from "@/components/admin/shared/sInputs.vue";
  import STable from "@/components/admin/shared/sTable.vue";
  import { BModal, BButton, BOverlay, BSpinner , BFormTextarea, BFormGroup,BFormFile} from "bootstrap-vue";
//import { or } from 'vuelidate/lib/validators';
  export default {
    mixins: [adminMixin],
    components: {
      BModal,
      BButton,
      BOverlay,
      BSpinner,
      StepIndicator ,
      SInputs,STable,
      BFormTextarea,
      BFormGroup,
      BFormFile,
      FilePreviewGrid
    },
    data() {
      return {
  //       invoice: {
  //       date: '',
  //       customer: { name: '', address: '' },
  //       items: [],
  //       total: 0,
  //       tax: 0,
  //       totalWithTax: 0
  //     },
  //       docDefinition : {
  // content: [
  //   { text: 'فاکتور', style: 'header' },
  //   { text: `تاریخ: ${this.invoice.data}` },
  //   { text: `نام مشتری: ${this.invoice.customer.name}` },
  //   // جدول اقلام
  //   {
  //     table: {
  //       headerRows: 1,
  //       widths: ['*', 'auto', 'auto', 'auto'],
  //       body: [
  //         ['شرح', 'تعداد', 'قیمت واحد', 'مجموع'],
  //         ...invoice.items.map(i => [i.description, i.qty, i.price, i.qty * i.price])
  //       ]
  //     }
  //   },
  //   { text: `کل: ${this.invoice.total}` }
  // ],
  // styles: {
  //   header: { fontSize: 18, bold: true }
  // },},
        //  invoiceData : {
        //      date: '2025-08-26',
        //      customer: { name: 'شرکت نمونه', address: 'تهران' },
        //     items: [
        //     { description: 'کالا A', qty: 2, price: 10000 },
        //     { description: 'کالا B', qty: 1, price: 20000 }
        //    ],
        //    total: 40000,
        //    tax: 4000,
        //     totalWithTax: 44000
        //  }, 
        descriptionOrder:"",
        totalAdditionalCost: 0,
        totalDiscount: 0 ,
        innerDisabled: false,
        folderRoute:"FactorCalibrationLabOrder",
       // baseMediaUrl: "https://localhost:7132/",
       // baseImageUrl: "https://localhost:7132/",
       // baseMediaUrl:"file:///D:/Alinezhad/MMC/SiteMargarine/Last/mrgarin-master__/mrgarin-master/Margaring/wwwroot/",
        baseMediaUrl: "https://test.mmc.ir/",
        files:"",
        disabled:false,
        forAdmin:false,
        message: "",
        messages:"",
        steps: ['ثبت سفارش', 'رد / تاييد سفارش', 'دريافت تجهيزات', 'شروع كاليبراسيون','در انتظار پرداخت','پايان كاليبراسيون'],
        currentStep: 1,
        disable: false,
        status: true,
        headers: [
          {
            style: "col-12",
            show_in_table: true,
            type: "string",
            multiData: false,
            name: "عنوان خبر",
            key: "newsTitle",
          },
          {
            style: "col-12",
            show_in_table: true,
            type: "string",
            multiData: false,
            name: "نام کاربری",
            key: "userName",
          },
  
          {
            style: "col-12",
            show_in_table: true,
            placeholder: "",
            type: "setting",
            name: "تنظیمات",
            multiData: false,
            key: "",
            edit: true,
            modal: true,
            buttonModalTitle: "درخواست ها",
            delete: true,
            editLabel: "ویرایش",
          },
        ],
        pageSize: 10,
        bigData: {
          persian: {},
          english: {},
          both: {},
        },
        userId: null,
       // message: "",
        sendModal: false,
        title: "آزمايشگاه كاليبراسيون",
        editedId: null,
        apiRoute: "CalibrationLabOrder",
        itemsList:null,
        //totalPrice:0,
      };
    },
    mounted() {
      this.getId();
      this.loadItems();
    },
  
    methods: {
      printInvoice(orderNumber) {
      // انتخاب بخش چاپی
      const printContents = this.$el.querySelector('#Preinvoice-template').outerHTML;

      // پنجره چاپی موقت
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
        <html>
          <head>
            <title> ${orderNumber}  پرینت پیش‌فاکتور</title>
            <style>
              /* استایل‌های پایه برای چاپ */
              body { padding: 5px;direction:rtl;font-family: 'yekan-medium', sans-serif;}
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #000; padding: 8px; text-align: right; }
              .totals { margin-top: 16px; }
              @media print {
                /* هر چیزی که لازم نیست چاپ نشود */
              }
               
div#customerContent p {
  min-width: 100%;
  direction: rtl;
  text-align: right;
}
div#customerContent span {
  padding: 10px 20px;
  min-width: 200px;
  text-align: right;
  direction: rtl;
  font-weight: bolder;
}
div#customerContent img {
  width: 210px;
  margin: auto;
}
div#customerContent {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.infoGroup div {
  display: flex;
  flex-direction: column;
}

.infoGroup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  direction: rtl;
}
.hideBorder{
  border-right: 0px;
  }
  .fullHideBorder{
  border: 0px;
  text-align:center;
  }
  .borderStyle{
    border-radius: 2%;border: 3px solid gray ; margin-top: 20px;margin-bottom: 10px;
    padding: 10px;
  }
  /* Footer استایل اختصاصی */
              .invoice-footer {
                position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    border-top: 1px solid #000;
    background: #fff;
              }
            </style>
          </head>
          <body>
            <h6  style="text-align:center;">  فرم پيش فاكتور آزمايشگاه كاليبراسيون </h6>
            <div class="borderStyle" >  
              <h3  style="text-align:center;">آزمايشگاه كاليبراسيون شركت سهامي عام مارگارين</h3>
            </div>
            ${printContents}
            <div style="font-size:10px;"> مستدعي است بابت مبلغ نهايي پيش فاكتور به حساب IR460210000001000202365606 و يا شماره كارت 6996-0024-6070-6277 پست بانك شركت مارگارين واريز فرماييد </div>
          <div  style="margin-top:90px; text-align:center;" >  
            <table >
              <tr>
                <td class="fullHideBorder">
                 <span> نام و امضاء مدير فني </span>  
                  <br>
                  <span>تاريخ</span>  
                 </td>
                 <td class="fullHideBorder"></td>
                 <td class="fullHideBorder"></td>
                <td class="fullHideBorder">
                 <span> نام و امضاء مشتري </span>  
                  <br>
                  <span>تاريخ</span>  
                 </td> 
            </tr>
            </table>
           </div>
           <footer class="invoice-footer">
              <div class="footer-content">
            <table>
            <tr>
             <td class="fullHideBorder">
             <span> آدرس: </span> تهران - شهر ري - كيلومتر 3 جاده ورامين 
            </td>
            <td class="fullHideBorder">  <span> تلفن: </span> 021-35811297 </td>
            </tr>
            <tr>
             <td class="fullHideBorder">
             <span> وب سايت: </span> https://mmc.ir/clab
            </td>
            <td class="fullHideBorder">  <span> پست الكترونيكي: </span> Calibration@margarineco.com </td>
            </tr>
           <table>
            </div>
           </footer> 
            </body>    
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      // اختیاری: بعد چاپ پنجره را ببندید
      // printWindow.close();
        },
    //     filters: {
    // currency(value) {
    //   if (typeof value !== 'number') return value;
    //   return value.toLocaleString('fa-IR', { style: 'currency', currency: 'IRR' });
    // }
    //  },
      currency (value) {
       if (typeof value !== 'number') return value;
       return value.toLocaleString('fa-IR', { style: 'currency', currency: 'IRR' });
      },
      currencyWithoutRial (value) {
       if (typeof value !== 'number') return  value;
       let v =   new Intl.NumberFormat('fa-IR').format(value);
       return  v.toLocaleString( { style: 'currency', currency: 'IRR' });
      },
     formatPersianNumber(n) {
       if (typeof n !== 'number') return n;
       // این فقط اعداد را با فواصل هزارگان نمایش می‌دهد و ارقام را فارسی می‌کند
        return new Intl.NumberFormat('fa-IR').format(n);
      },
      sendMessageCustomer(id,role) {
       // debugger;
       if( role =='CalibrationLab')
       {
         this.forAdmin=true;
       }
       else{
        this.forAdmin=false;
       }
        let pack = {
          userId: this.userId,
          message: this.message,
          calibrationLabOrderId: id, //this.selectedItem.calibrationLabOrderId,
          isRead: false,
          forAdmin: this.forAdmin,
          replyTo: null,
        };
        this.$axios
          .post(`CalibrationLabMessage`, pack)
          .then((res) => {
            this.$toast.success(res.data.message);
            this.message = "";
          //  this.showModal = false;
            this.loadItems();
          })
          .catch((err) => {
            this.$toast.error(err.response.data.message);
          });
      },
      sendMessage(id) {
        let pack = {
          userId: this.userId,
          message: this.message,
          calibrationLabOrderId: id, //this.selectedItem.calibrationLabOrderId,
          isRead: false,
          forAdmin: false,
          replyTo: null,
        };
        this.$axios
          .post(`CalibrationLabMessage`, pack)
          .then((res) => {
          //  this.$toast.success(res.data.message);
            this.message = "";
          //  this.showModal = false;
           // this.loadItems();
          })
          .catch((err) => {
            this.$toast.error(err.response.data.message);
          });
      },
      sendReceiptDeposit(item){
        let url = "";
       let type="File";
       // if(this.files == '' && item.statusId == 5)
       // {
       //   return this.$toast.error("آپلود کردن پيش فاكتور الزامی است");
        //}
       // else
       if(this.files != '' )
        {
          let formData = new FormData();
          this.files.forEach((f) => {
           formData.append("files", f);
          });
          formData.append("SavePath", this.folderRoute + (type === "video" ? "Video" : "File"));

          const config = {  
             onUploadProgress: (progressEvent) => {  
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);  
            if (this.innerDisabled === false) {  
              //this.$toast.info(`درحال آپلود ${type === "video" ? "ویدیو" : "فایل"}: ${percentCompleted}%`); 
              this.$toast.info(`درحال آپلود ${type === "video" ? "ویدیو" : "فایل"}`);  
            }  
            this.innerDisabled = true;  
         }  
          };  
  //debugger;
       this.$axios  
       .post(  
      `Files/UploadFiles?SavePath=${this.folderRoute}&OrderNumber=${item.orderNumber}`,  
      formData,  
        config  
      )  
    .then((response) => {  
      url = response.data.data;  
      this.updateUrlFileOrderStatus(url,item.orderNumber,item.statusId);
      this.$toast.success("فایل با موفقیت آپلود شد");  
      // استفاده از url در ادامه  
    })  
   .catch(() => {
            this.$toast.error(
             "خطایی در آپلود فايل به وجود آمده است , لطفا صفحه را بروز رسانی کنید"
            );
           });
         //  return url;
           }
      ///////////////////////////////         
         },
    async   updateUrlFileOrderStatus(savePath,orderNumber,statusId){

      await this.$axios
        // .post("CalibrationLabOrder/UpdateUrlFileOrderStatus", JSON.stringify(pack), {
        //   headers: {
        //     // Overwrite Axios's automatically set Content-Type
        //     "Content-Type": "application/json",
        //   },
        // })
        .post(  
      `CalibrationLabOrder/UpdateUrlFileOrderStatus?SavePath=${savePath}&OrderNumber=${orderNumber}&StatusId=${statusId}`
      )  
        .then(() => {           
               this.$toast.success(".ثبت با موفقیت انجام گرديد");
        })
        .catch((error) => {
          this.disabled = false;
          let arrayError = error.response.data.message.split("|");
          arrayError.forEach((err, index) => {
            if (index < 1) {
              this.$toast.error(err, {
                timeout: 1000 * (index + 4),
                pauseOnHover: true,
              });
            }
          });
        });
     },
      async nextStep(item,statusIdNew) {
      //  debugger;
        let url = "";
        if(this.message == '' && statusIdNew == 3)
        {
          return this.$toast.error("وارد كردن پيام الزامی است");
        }
      //  let type="File";
      //   if(this.files == '' && item.statusId == 5)
      //   {
      //     return this.$toast.error("آپلود کردن پيش فاكتور الزامی است");
      //   }
      //   else if(this.files != '' && item.statusId == 5)
      //   {
      //     let formData = new FormData();{
      //     formData.append("file", this.files);
      //      var config = {
      //      onUploadProgress: () => {
      //     if (this.innerDisabled == false) {
      //       if (type == "video") {
      //         this.$toast.info("درحال آپلود ویدیو");
      //       } else {
      //         this.$toast.info("درحال آپلود فایل");
      //       }
      //     }
      //     this.innerDisabled = true;
      //       },
      //     };
      //     await this.$axios
      //     .post(
      //       `Files/UploadFile?SavePath=${this.folderRoute}${
      //         type == "video" ? "Video" : "File"
      //      }`,
      //     formData,
      //     config
      //     )
      //     .then((response) => {
      //       url = response.data.data;
      //      })
      //       .catch(() => {
      //       this.$toast.error(
      //        "خطایی در آپلود فايل به وجود آمده است , لطفا صفحه را بروز رسانی کنید"
      //       );
      //      });
      //      //return url;
      //     }
      //    }
      //********************************** */
      this.disabled=true;
       let pack = {
        statusId : statusIdNew,
        userId: item.userId,
        orderNumber:  item.orderNumber,
       // urlFactor : url != '' ? url : item.urlFactor  ,
       urlFactor : url != '' ? url : null  ,
        nameFactor : this.files.name ,
        totalAdditionalCost : statusIdNew == 6  ? this.totalAdditionalCost : item.totalAdditionalCost ,
        totalDiscount : statusIdNew == 6  ?  this.totalDiscount : item.totalDiscount,
        totalTax : this.taxOnCart,// this.totalTax,
        totalPrice : this.finalAmountWithTax, //this.totalAmount + this.totalTax
        descriptionOrder : this.descriptionOrder
        };
       // debugger;
        await this.$axios
        .post("CalibrationLabOrder/ChangeCalibrationLabOrdeStatus", JSON.stringify(pack), {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json",
          },
        })
        .then(() => {           
               this.sendMessage(item.id);
               this.$toast.success(".ثبت با موفقیت انجام گرديد");
               this.resetModal();
               this.loadItems();
               this.currentStep = statusIdNew -1;
               this.disabled=false;
        })
        .catch((error) => {
          this.disabled = false;
          let arrayError = error.response.data.message.split("|");
          arrayError.forEach((err, index) => {
            if (index < 1) {
              this.$toast.error(err, {
                timeout: 1000 * (index + 4),
                pauseOnHover: true,
              });
            }
          });
        });
         
        },
      // sendMessage() {
      //   let pack = {
      //     userId: this.userId,
      //     message: this.message,
      //   };
      //   this.$axios
      //     .post("SupplierMessage", JSON.stringify(pack), {
      //       headers: {
      //         // Overwrite Axios's automatically set Content-Type
      //         "Content-Type": "application/json",
      //       },
      //     })
      //     .then((res) => {
      //       this.resetSendModal();
      //       this.$toast.success(res.data.message);
      //     })
      //     .catch((err) => {
      //       this.$toast.error(err.response.data.message);
      //     });
      // },
      showSendModal(id) {
        this.userId = id;
        this.sendModal = true;
      },
      resetSendModal() {
        this.message = "";
        this.sendModal = false;
      },
       loadItems() {
        this.$axios.get(`${this.apiRoute}/${this.$route.query.id}`).then((response) => {
        this.status = false;
        this.item = response.data.data;//this.convertToBigData(response.data.data);
        if (this.item.statusId == 1 || this.item.statusId == 2)
        {
           this.currentStep = this.item.statusId -1 ;
        }
        else
        {
          this.currentStep=this.item.statusId -2;
        }
      });
      this.mode = "edit"; 
      //this.$axios.get(`CalibrationLabOrder/GetOrdersDetail?OrderNumber=${item.orderNumber}`).then((res) => {
       // this.bigData.both.OrderNumber = res.data.data;
       this.$axios.get(`CalibrationLabOrder/GetOrdersDetail?Id=${this.$route.query.id}`).then((res) => {
        this.itemsList = res.data.data;
       // debugger;
       // this.showModal = true;
       this.editModel = true;
         });
         //------------------------------------------
         this.$axios.get(`CalibrationLabMessage/GetMessage?calibrationLabOrderId=${this.$route.query.id}`).then(res=>{
          this.messages=res.data.data;
         // this.showModal = true;
          setTimeout(() => {
            document
              .getElementById("blogModal___BV_modal_content_")
              .removeAttribute("tabindex");
          });
        }).catch(err=>{
          this.$toast.error(err.response.data.message)
        })
       },
    },
    computed:{
     getRole() {
      //debugger;
      if (this.$store.getters.getAdminPanelRole == null) {
        return "";
      } else {
        return this.$store.getters.getAdminPanelRole;
      }
     },
totalAmount() {
  // مجموعPrice با در نظر گرفتن تخفیف کل هر آیتم
  return this.itemsList.reduce((sum, item) => {
    const itemDiscount = item.discount || 0; // تخفیف کل آیتم
    const itemTotal = (item.price * item.number) - itemDiscount;
    return sum + Math.max(0, itemTotal);
  }, 0);
},

netAmount() {
  // پایه به‌همراه هزینه‌های اضافی و کسر کل تخفیف
  const base = (this.totalAmount + (Number( this.totalAdditionalCost) || 0));
  // totalDiscount فرضاً مقدار تخفیف کل کل سبد است (به پول)
  const discountPercent = Number( this.totalDiscount )|| 0;
  const discountAmount = (base * discountPercent) / 100;

  return Math.max(0, base - discountAmount);
 // return Math.max(0, base - ( Number( this.totalDiscount) || 0));
},

taxOnCart() {
  //debugger;
  const taxRate = 0.10;
  return this.netAmount * taxRate;
},

finalAmountWithTax() {
  //debugger;
  return this.netAmount + this.taxOnCart;
},
//     //************************************************ */
     // مجموع مالیات کل، در صورت وجود فیلد مالیات در هر آیتم
    //  totalTax() {
    //   return this.itemsList.reduce((tax, item) => {
    //   return tax + (item.price * item.number) *(10/100);
    //   }, 0);
    //  }

    // totalTax() {
    //   // فرض می‌کنیم مالیات بر کل مبلغ پس از افزودن هزینه‌های اضافی و کسر تخفیف محاسبه می‌شود
    //   const sumItems = this.itemsList.reduce((sum, item) => {
    //   //  const itemDiscount = item.discount || 0;
    //     const itemTotal = (item.price * item.number) ; // - itemDiscount;
    //     return sum + itemTotal;//Math.max(0, itemTotal);

    //   }, 0);

    //   const base = sumItems + (this.totalAdditionalCost || 0);
    //   const taxableAmount = Math.max(0, base - (this.totalDiscount || 0));

    //   const taxRate = 0.10; // 10%
    //   return taxableAmount * taxRate;
    // }
    }
 ,

  };


  </script>
  <style>
  .hideBorder{
    border-right: 0px;
  }
  .disableLink {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
    .headerStyle {
    direction: rtl;
    text-align: right;
  }
  div#messages p.calibrationLabMessage {
    align-self: end;
    background: #0088cc;
  }
  div#messages {
    display: flex;
    flex-direction: column-reverse;
  }
  div#messages p {
    background: yellowgreen;
    width: 350px;
    color: white;
    align-self: start;
    text-align: right;
    padding: 8px;
    border-radius: 8px;
    direction: rtl;
    font-size: 16px;
    white-space: pre-wrap;
  }
  /* ************************************ */
  .borderStyle{
    border-radius: 2%;border: 1px solid gray ; margin-top: 20px;margin-bottom: 10px;
    padding: 10px;
  }
  .links {
  display: flex;
  gap: 8px;
}
  div#headersList {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  div#sendMessageContent textarea {
    padding: 15px;
  }
  div#sendMessageContent input[type="submit"] {
    background: green;
    color: white;
    padding: 10px 24px;
    border: chartreuse;
    border-radius: 4px;
  }
  
  div#sendMessageContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    direction: rtl;
  }

  
div#customerContent p {
  background: #80808042;
  padding: 10px 20px;
  min-width: 100%;
  min-height: 50px;
  direction: rtl;
  text-align: right;
}
div#customerContent span {
  /* background: #80808042; */
  padding: 10px 20px;
  min-width: 200px;
  text-align: right;
  direction: rtl;
  font-weight: bolder;
}
div#customerContent img {
  width: 210px;
  margin: auto;
}
div#customerContent {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  padding: 15px;
}
.infoGroup div {
  display: flex;
  flex-direction: column;
}

.infoGroup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  justify-content: space-between;
  gap: 10px;
  direction: rtl;
}
#preInvoice-print{
  direction: rtl;
}
#Preinvoice-template{
  direction: rtl;
}
  </style>
  